import { SET_ALL_COMPANIES } from "../../constants";

export const getAllCompanies = (state: any = null, action: any) => {
  switch (action.type) {
    case SET_ALL_COMPANIES:
      return action.payload;
    default:
      return state;
  }
};
